import type { BridgeMode } from '../../../../shared/drafts';

/** `awaiting-drive`: doğru modülle kurulan köprüde öğrencinin gaz pedalına basması beklenir. */
export type BridgePhase = 'intro' | 'awaiting-answer' | 'feedback' | 'bridge-building' | 'awaiting-drive' | 'rover-crossing' | 'camera-travel' | 'finished' | 'game-over';

type EvaluationInput = { mode: BridgeMode; score: number; lives: number; streak: number };
type Evaluation = {
  score: number;
  lives: number;
  streak: number;
  correctDelta: number;
  wrongDelta: number;
  attemptsDelta: number;
  shouldBuildBridge: boolean;
  shouldStayOnQuestion: boolean;
  showCorrectChoice: boolean;
  outcome: 'correct' | 'wrong' | 'timeout';
  livesLost: number;
  scoreDelta: number;
};

export function evaluateChoice(_input: EvaluationInput, _correct: boolean): Evaluation {
  if (_correct) {
    const nextStreak = _input.streak + 1;
    const reward = 100 + Math.min(40, (nextStreak - 1) * 10);
    return {
      score: _input.score + reward,
      lives: _input.lives,
      streak: nextStreak,
      correctDelta: 1,
      wrongDelta: 0,
      attemptsDelta: 1,
      shouldBuildBridge: true,
      shouldStayOnQuestion: false,
      showCorrectChoice: false,
      outcome: 'correct',
      livesLost: 0,
      scoreDelta: reward,
    };
  }

  if (_input.mode === 'guided') {
    return {
      score: _input.score,
      lives: _input.lives,
      streak: 0,
      correctDelta: 0,
      wrongDelta: 1,
      attemptsDelta: 1,
      shouldBuildBridge: true,
      shouldStayOnQuestion: false,
      showCorrectChoice: true,
      outcome: 'wrong',
      livesLost: 0,
      scoreDelta: 0,
    };
  }

  const score = Math.max(0, _input.score - 25);
  const lives = Math.max(0, _input.lives - 1);
  return {
    score,
    lives,
    streak: 0,
    correctDelta: 0,
    wrongDelta: 1,
    attemptsDelta: 1,
    shouldBuildBridge: false,
    shouldStayOnQuestion: lives > 0,
    showCorrectChoice: lives === 0,
    outcome: 'wrong',
    livesLost: _input.lives - lives,
    scoreDelta: score - _input.score,
  };
}

export function evaluateTimeout(_input: EvaluationInput): Evaluation {
  if (_input.mode === 'guided') {
    return {
      score: _input.score,
      lives: _input.lives,
      streak: 0,
      correctDelta: 0,
      wrongDelta: 1,
      attemptsDelta: 1,
      shouldBuildBridge: true,
      shouldStayOnQuestion: false,
      showCorrectChoice: true,
      outcome: 'timeout',
      livesLost: 0,
      scoreDelta: 0,
    };
  }

  const score = Math.max(0, _input.score - 50);
  const lives = Math.max(0, _input.lives - 2);
  return {
    score,
    lives,
    streak: 0,
    correctDelta: 0,
    wrongDelta: 1,
    attemptsDelta: 1,
    shouldBuildBridge: false,
    shouldStayOnQuestion: lives > 0,
    showCorrectChoice: lives === 0,
    outcome: 'timeout',
    livesLost: _input.lives - lives,
    scoreDelta: score - _input.score,
  };
}

export function advanceBridgeTimer(_phase: BridgePhase, _remainingMs: number, _deltaMs: number) {
  if (_phase !== 'awaiting-answer') return { remainingMs: _remainingMs, timedOut: false };
  const remainingMs = Math.max(0, _remainingMs - Math.max(0, _deltaMs));
  return { remainingMs, timedOut: remainingMs === 0 && _remainingMs > 0 };
}

export function advanceJourney(_state: { segment: number; roverX: number; cameraX: number }) {
  const segmentLength = 920;
  return {
    segment: _state.segment + 1,
    roverX: _state.roverX + segmentLength,
    cameraX: _state.cameraX + segmentLength,
  };
}
